import { api } from "./api";

export const enviarFeedback = async (feedbackData) => {
  const { data } = await api.post("/feedback/guardar", feedbackData);
  return data;
};

export const getFeedbacks = async () => {
  const { data } = await api.get("/feedback/obtenerTodos");
  return data;
};
